/** HC - nutririon metafield in product page - 21 Oct '21 **/
(function() {
  window.addEventListener('shopify-variants:switch-variant', e => {
    const variant = e.detail.variant; 
    const img = document.querySelector('.hc-nutrition-content'); 
    const newSrc = img.dataset[variant.id];
    img.style.opacity = 0;
    
    if (newSrc) {
      img.src = newSrc;
      img.style.display = 'block';
    } else {
      img.style.display = 'none';
    }
  });
  
  window.addEventListener('DOMContentLoaded', _ => {
    const img = document.querySelector('.hc-nutrition-content');
    img.addEventListener('load', () => img.style.opacity = 1);
  });
})();